import type { Location } from "../../entity/Location"
import { translate } from "../../util/translate"

type Description = {
  long: Array<string>,
  longLocal: Array<string>
}

const fullData: Record<string, Record<string, Description>> = {}

export default class TreatmentSmallDescriptionRepository {
  public static getDescriptionBySlug(slug: string) {
    const data = fullData[slug]

    if (data) {
      const { long } = translate(data)
      return { long }
    }

    return { long: [] }
  }

  public static getLocalizedDescriptionBySlug(slug: string, location: Location) {
    const data = fullData[slug]

    if (data) {
      const { longLocal } = translate(data)

      const long = longLocal.map((line) => {
        return line.replaceAll('{loc}', location.label)
      })

      return { long }
    }

    return { long: [] }
  }
}
